function getBackgroundColor(args) {
    const {row: row, table: table} = args;
    return 1 & row - table.frozenRowCount ? "#fbfbfc" : "#FFF";
}

export default {
    name: "ARCO",
    underlayBackgroundColor: "#FFF",
    defaultStyle: {
        color: "#1B1F23",
        bgColor: "#EEF1F5",
        fontSize: 14,
        fontFamily: "Arial,sans-serif",
        fontWeight: 600,
        lineHeight: 14,
        borderColor: "#e1e4e8",
        padding: [ 8, 12, 8, 12 ]
    },
    headerStyle: {
        color: "#1B1F23",
        bgColor: "#EEF1F5",
        fontSize: 14,
        fontFamily: "Arial,sans-serif",
        fontWeight: 600,
        lineHeight: 14,
        borderColor: "#e1e4e8",
        padding: [ 8, 12, 8, 12 ],
        hover: {
            cellBgColor: "#c8daf6"
        }
    },
    rowHeaderStyle: {
        color: "#1B1F23",
        bgColor: "#EEF1F5",
        fontSize: 12,
        fontFamily: "PingFang SC",
        fontWeight: 500,
        lineHeight: 12,
        borderColor: "#e1e4e8",
        padding: [ 8, 12, 8, 12 ],
        hover: {
            cellBgColor: "#c8daf6"
        }
    },
    cornerHeaderStyle: {
        color: "#1B1F23",
        bgColor: "#EEF1F5",
        fontSize: 12,
        fontFamily: "PingFang SC",
        fontWeight: 500,
        lineHeight: 12,
        borderColor: "#e1e4e8",
        padding: [ 8, 12, 8, 12 ],
        hover: {
            cellBgColor: "#c8daf6"
        }
    },
    bodyStyle: {
        padding: [ 8, 12, 8, 12 ],
        color: "#141414",
        fontSize: 14,
        fontFamily: "Arial,sans-serif",
        fontWeight: 400,
        textAlign: "left",
        bgColor: getBackgroundColor,
        borderColor: "#e1e4e8",
        lineHeight: 14,
        hover: {
            cellBgColor: "#F7F8FA",
            inlineRowBgColor: "#F3F8FF",
            inlineColumnBgColor: "#F3F8FF"
        }
    },
    frameStyle: {
        borderColor: "#d1d5da",
        borderLineWidth: 1,
        borderLineDash: [],
        cornerRadius: 4,
        shadowBlur: 6,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "rgba(00, 24, 47, 0.06)"
    },
    columnResize: {
        lineWidth: 1,
        lineColor: "#416EFF",
        bgColor: "#D9E2FF",
        width: 3
    },
    frozenColumnLine: {
        shadow: {
            width: 4,
            startColor: "rgba(00, 24, 47, 0.05)",
            endColor: "rgba(00, 24, 47, 0)",
            visible: "always"
        }
    },
    selectionStyle: {
        cellBgColor: "rgba(0, 0, 255,0.1)",
        cellBorderLineWidth: 2,
        cellBorderColor: "#3073f2"
    },
    tooltipStyle: {
        bgColor: "#FFF",
        color: "#000",
        fontSize: 12,
        fontFamily: "Arial,sans-serif"
    }
};
//# sourceMappingURL=ARCO.js.map
